var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.361395 0.361895C0.84358 -0.120306 1.62541 -0.120306 2.10761 0.361895L4.14474 2.39911L6.18187 0.361895C6.66407 -0.120306 7.4459 -0.120306 7.9281 0.361895C8.41031 0.84408 8.41031 1.62584 7.9281 2.10804L5.89097 4.14518L7.9281 6.18247C8.41031 6.66467 8.41031 7.44634 7.9281 7.92854C7.4459 8.41074 6.66407 8.41074 6.18187 7.92854L4.14474 5.89141L2.10761 7.92854C1.62541 8.41074 0.84358 8.41074 0.361395 7.92854C-0.12079 7.44634 -0.12079 6.66467 0.361395 6.18247L2.39851 4.14518L0.361395 2.10804C-0.12079 1.62584 -0.12079 0.84408 0.361395 0.361895Z",
    fill: "#FF5900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.bf257578709e105b7b9f633aeb82e217.svg";
export { ForwardRef as ReactComponent };